<template>
  <div class="container">
    <div>
      <div>
        <i class="el-icon-success el-icon" style="color: #52c41a"></i>
        <span class="tips">订单换货确认成功</span>
      </div>
      <div class="font">
        <p>您的订单商品换货已提交成功，</p>
        <p>如需更多信息可前往擎科官网进行查看</p>
      </div>
      <el-button class="button" @click="handlerJump">擎科官网</el-button>
    </div>
  </div>
</template>

<script>
import { confirmExchangeGoods } from '@/services/api.index'

export default {
  created() {
    const { id } = this.$route.query;
    confirmExchangeGoods(id)
  },
  methods: {
    handlerJump() {
      this.$router.push('/')
      this.$router.go(0)
    }
  }
}

</script>

<style scoped lang="scss">
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; 
  text-align: center;
  .tips {
    font-size: 30px;
    font-weight: bold;
    margin: 50px 0;
  }
  .font {
    text-align: left;
    margin: 35px 0 45px 80px;
    font-size: 15px;
    line-height: 30px;
  }
  .el-icon {
    font-size: 50px;
  }
  .button {
    padding: 13px 55px;
    background-color: #169bd5;
    color: #fff;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/products/confirmExchangeSuccess.vue